import React from "react";
import { formatDateDDMMYYYY } from "../../../utils/commonFunctions";
function ResponseView({ responses }) {
  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <tbody>
          {responses?.map((response, k) => {
            let value = response.value;
            if (response.element.type === "checkbox") {
              value = value.join(", ");
            }
            if (response?.element?.type === "date") {
              value = formatDateDDMMYYYY(new Date(value))
          }
            if (response.element.type === "texttable") {
              value = (
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        {response.element.properties.options.map(
                          (option, k) => (
                            <th key={k}>{option}</th>
                          )
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {Object.values(JSON.parse(response.value)).map((v, k) => (
                        <tr key={k}>
                          {Object.values(v).map((value, key) => (
                            <td key={key}>{value}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              );
            }
            if (response.element.type !== "file") {     
              return (
                <tr key={k}>
                  <td width="50%" className="w-50"><strong>{response.label}</strong></td>
                  <td width="50%" className="w-50"><span>{value}</span></td>
                </tr>
              );
            }
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ResponseView;
